export default __webpack_public_path__ + "static/brazil-de07f9c517efc3dc16fe5e9808754770.svg";